import { render, staticRenderFns } from "./TeacherWorkRecommend.vue?vue&type=template&id=701cbde4&scoped=true"
import script from "./TeacherWorkRecommend.vue?vue&type=script&lang=js"
export * from "./TeacherWorkRecommend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "701cbde4",
  null
  
)

export default component.exports